// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RestrictedRangeSlider_wrapper__RKToI","disabledOverlay":"RestrictedRangeSlider_disabledOverlay__JoZdj"};